module.exports = __webpack_public_path__ + "img/2.386dfb47.jpg";